import { useState,useEffect } from "react";
import { Link,useParams } from "react-router-dom";
import { REPORT_BASE_URL } from "../../../../config/ApiConfig";
import html2pdf from 'html2pdf.js';
import axios from "axios";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export const CspTemporaryPass=()=>{
    const [temporaryPass,setTemporaryPass]=useState({});
    const [email,setEmail]=useState('');
    const [expirationDate,setExpirationDate]=useState();
    const [error,setError]=useState('');
    const params = useParams();
    const {passGUID} = params;
    useEffect(() => {
        const navElement = document.querySelector('nav');
        if (navElement) {
            navElement.style.setProperty('display', 'none', 'important');
        }
    }, []);
    useEffect(()=>{
        if(passGUID){
            fetchTemporaryPass(); 
        }   
    },[passGUID]);

    //Format Date
    const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        if (isNaN(date)) {
            return 'Invalid Date';
        }
        const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date); 
        const day = String(date.getDate()).padStart(2, '0'); 
        const year = date.getFullYear();
        return `${monthName} ${day}, ${year}`;
    };
    //Fetch TemporaryPass
    const fetchTemporaryPass=async()=>{
        try {
            const response = await axios.get(`${REPORT_BASE_URL}/GetTemporaryPassByGUID/${passGUID}`);
            if(response.status==200){
                const formattedDate = formatDate(response.data.data.expirationDate);
                setExpirationDate(formattedDate);
                setEmail(response.data.data.email);
                setTemporaryPass(response.data.data);
            }
          } catch (error) {
            if(error.response.status==404){
                setError(error.response.data.message)
            }else{
                setError('We encountered an issue while fetching temporary pass detials. Please refresh the page or try again later');
            }
        }
    }
    //DownloadPdf-
    const downloadPdf = async (passGUID) => {
        try {
            const response = await axios.get(`${REPORT_BASE_URL}/GenerateTemporaryPassHTML?passGuid=${passGUID}`);
            
            if (response.status === 200 && response.data?.data) {
                const htmlContent = response.data.data.trim(); // Remove trailing spaces/newlines

                const currentDate = new Date();
                const formattedDate = `${currentDate.getMonth() + 1}_${currentDate.getDate()}_${currentDate.getFullYear()}_${currentDate.getHours()}_${currentDate.getMinutes()}_${currentDate.getSeconds()}`;
                const filename = `TemporaryPass_Annual_Pass_${formattedDate}.pdf`;
    
                await html2pdf()
                    .from(htmlContent)
                    .set({
                        margin: [0, 0, 0, 0],
                        filename:filename,
                        html2canvas: {
                            scale: 2,
                            scrollX: 0,
                            scrollY: 0,
                            useCORS: true
                        },
                        jsPDF: {
                            unit: 'mm',
                            format: 'a4',
                            orientation: 'portrait',    // Customize the PDF format
                            compress: true
                        },
                        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
                    })
                    .save();
            } else {
                console.error('Failed to generate HTML content.');
            }
        } catch (error) {
            console.error("Error while downloading PDF:", error);
        }
    };
    return(
        <>
        <div className="passes-container my-5">
            <div className="orderPass">
                { error ? (
                    <h2 className='errorHandled'>{error}</h2>
                ) : Object.keys(temporaryPass).length === 0 ? (
                    <div className="skeleton-wrapper d-flex flex-column">
                        <Skeleton height={30} width="100px" />
                        <Skeleton height={15} width="60%" />
                        <Skeleton height={15} width="50%" />
                        <Skeleton height={100} width="100%" />
                        <Skeleton height={30} width="40%" />
                        <Skeleton count={5} width="80%" />
                    </div>
                    ) : (
                        <>
                            <h2 className='greet'>Thank you!</h2>
                            <p className='hide-print'>
                                A confirmation email is on its way to <strong>{email}</strong> which contains a link to this page so you can view and print your passes when you are ready. If you are unable to print, write the transaction number and date from your printable PDF pass on a piece of paper in large bold print and display it on your car's dashboard.
                            </p>
                            <div className="passes-wrap d-flex justify-content-between">
                                <div className="print-pass-section">
                                    <div className="passes-head">Print Your Pass (PDF)</div>
                                    <Link className="pass-link"  onClick={() => downloadPdf(passGUID)}>TEMPORARY Annual Discover Pass<span className="expires">{`(Expires ${expirationDate})`}</span>
                                    </Link>
                                </div>
                                <div className="passes-more">
                                    <div className="passes-more-box">
                                        <Link to="https://public.govdelivery.com/accounts/WAPARKS/subscriber/new" target="_blank">Stay connected</Link>
                                        Sign up for updates from your Washington state recreation lands
                                    </div>
                                    <div className="passes-more-box">
                                        <Link to="http://www.discoverpass.wa.gov/143//Washington-Recreation-Lands" target="_blank">Where can I use my pass?</Link>
                                        Explore Washington state recreation lands
                                    </div>
                                    <div className="passes-more-box">
                                        <Link to="https://fishhunt.dfw.wa.gov" target="_blank">Need a fishing or hunting license?</Link>
                                        Purchase your license today
                                    </div>
                                    <div className="passes-more-box">
                                        <Link to="http://www.discoverpass.wa.gov/143//Washington-Recreation-Lands" target="_blank">Support your public lands</Link>
                                        Make a donation to Washington state recreation lands
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
        </>
    )
}